import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import messages from './local/index';

// Get saved language from localStorage or default to 'en'
const savedLanguage = localStorage.getItem('lang') || 'en';

i18n
  .use(initReactI18next)
  .init({
    lng: savedLanguage,
    fallbackLng: 'en',
    debug: true, // Enable debug to see language changes in console
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
    // Prevent showing keys when translation is missing
    returnNull: false,
    returnEmptyString: false,
    saveMissing: false,
    // Use fallback language value instead of key
    parseMissingKeyHandler: () => '',
    react: {
      useSuspense: false,
    },
  });

// Listen for language changes and save to localStorage
i18n.on('languageChanged', (lng) => {
  console.log('Language changed to:', lng);
  localStorage.setItem('lang', lng);
});

export default i18n;
